import React, { useContext } from 'react';
import cn from 'classnames';
import ReactTyped from 'react-typed';

import styles from './MainView.module.css';
import baseStyles from '../../App.module.css';
import avatar from '../../images/avatar/avatar.webp';
import Socials from './Socials';
import LanguageContext from '../context/LanguageContext';
import {
    callMe,
    callmeUA,
    downloadCV,
    downloadCVUA,
    name,
    nameUA,
    specialty,
    specialtyUA,
} from '../../data/mainData';
import { myBioInfo } from '../../data/bioInfo';

export default function MainView({ isMobile }) {
    const { language } = useContext(LanguageContext);

    const phoneNumber = myBioInfo.find((el) => el.key === 'phone').value;

    console.log(phoneNumber);

    return (
        <div className={cn(styles.mainView, baseStyles.mainView)}>
            <div className={cn(styles.card)}>
                <div className={cn(styles.imgWrapper)}>
                    <img
                        src={avatar}
                        alt="avatar was here"
                        width="540"
                        height="445"
                    />
                </div>
                <h1 className={cn(styles.title, { [styles.active]: isMobile })}>
                    {language === 'en' ? name : nameUA}
                </h1>
                <span className={cn(styles.runningLine)}>
                    <ReactTyped
                        strings={language === 'en' ? specialty : specialtyUA}
                        typeSpeed={50}
                        backSpeed={10}
                        loop
                    />
                </span>
                <div className={cn(styles.socials)}>
                    <Socials />
                </div>
                <div
                    className={cn(styles.linksWrapper, {
                        [styles.ua]: language === 'ua',
                    })}
                >
                    <a
                        href="https://drive.google.com/file/d/1r0da0lWCWblw6RZm3R2HHWQL6lxkxqzO/view"
                        className={cn(styles.download, styles.link)}
                        target="_blank"
                        rel="noreferrer"
                        aria-label="google-drive-cv"
                    >
                        <span>
                            {language === 'en' ? downloadCV : downloadCVUA}
                        </span>
                    </a>
                    <a
                        href={`tel:${phoneNumber}`}
                        className={cn(styles.contactMe, styles.link)}
                        aria-label="phone-number"
                    >
                        <span>{language === 'en' ? callMe : callmeUA}</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
